// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e030b5e","eventName":"_899ceee","iconWrapper":"_615bc29","eventInfoWrapper":"_48bcb21"};